import { createClient } from '@supabase/supabase-js'

// Variables d'environnement Supabase
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Vérification des variables d'environnement
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Variables d\'environnement manquantes:')
  console.error('REACT_APP_SUPABASE_URL:', supabaseUrl ? '✓' : '✗')
  console.error('REACT_APP_SUPABASE_ANON_KEY:', supabaseAnonKey ? '✓' : '✗')
  throw new Error('Configuration Supabase incomplète. Vérifiez vos fichiers .env')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)